module.exports = __webpack_public_path__ + "img/my.6dbcb040.png";